import { render, staticRenderFns } from "./ExpertEvaluationTable.vue?vue&type=template&id=268ee349&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ExpertEvaluationTable.vue?vue&type=script&lang=js&"
export * from "./ExpertEvaluationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ee349",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VDataTable,VIcon,VTooltip})
